import { ViewChild, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core'
import { Component } from '@angular/core'
import { Subscription } from 'rxjs'
import { GiftService } from 'src/lib/services/gift-service'
import { GiftMeta, LiveComment } from "src/lib/entity/live"
import { environment } from "src/env/environment"
import { MagliveApiClient } from "src/lib/api-client/maglive-api-client"
import { AngularFirestore } from "@angular/fire/firestore"
import { GiftAnimationReq } from 'src/lib/entity/gift-point'
@Component({
  selector: 'maglive-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss']
})
export class CommentListComponent implements OnInit {

  @Input() liveId: string
  @Input() horizontal: boolean
  @Output() setAnimationEvent = new EventEmitter<GiftAnimationReq>()

  baseURL = environment.baseURL
  getUserIconURL = MagliveApiClient.getUserIconURL
  isBottom = true

  comments$ = this.giftService.comments$
  private commentLimit = 1000

  isFirstLoadCompleted = false

  @ViewChild("commentContainer", {static: true}) container: ElementRef<HTMLInputElement>
  private subscription: Subscription

  constructor(
    private afs: AngularFirestore,
    private giftService: GiftService,
  ) {}

  ngOnInit() {
    this.resubscribeComments()
  }

  private resubscribeComments() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }

    // レンダリング後にスクロールバーを最下部に移動させないといけないため、async pipe が使えない
    this.subscription = this.afs.collection<LiveComment>(`lives/${this.liveId}/comments`, ref =>
      ref.limit(this.commentLimit).orderBy("createdAt", "desc")
    ).valueChanges().subscribe(comments => {
      this.giftService.commentsSubject.next(comments.filter(e => e.status !== "DELETED").reverse()) // コメントを BAN にしたら見れなくする 下のコメントを最新にするので reverse

      this.giftService.latestCommentsSubject.next(this.giftService.commentsSubject.getValue().slice(-1)[0])

      // コメントがない場合エラーになるため条件分岐
      if (this.giftService.commentsSubject.getValue().slice(-1)[0]) {
        this.giftService.giftMetaSubject.next(this.giftService.commentsSubject.getValue().slice(-1)[0].giftMeta)
      }
      // 初回画面表示時はアニメーションをスキップ。新しいコメントが投稿された時かつアニメーション表示が必要な時だけ発火させる
      if (this.isFirstLoadCompleted && this.giftService.giftMetaSubject.getValue() != null) {
        this.startAnimation(this.giftService.giftMetaSubject.getValue())
      }
      this.isFirstLoadCompleted = true

      if (this.isBottom) {
        this.scrollToBottom()
      }
    })
  }

  scrollToBottom() {
    CommentListComponent.heightLog(this.container.nativeElement)
    setTimeout(() => {
      this.container.nativeElement.scrollTop = this.container.nativeElement.scrollHeight - this.container.nativeElement.offsetHeight
    }, 30)
  }

  onScroll() {
    // CommentListComponent.heightLog(this.container.nativeElement)
    this.isBottom = this.container.nativeElement.scrollTop === this.container.nativeElement.scrollHeight - this.container.nativeElement.offsetHeight

    /*
    // 先頭までスクロールしたら追加読み込み
    if (this.container.nativeElement.scrollTop === 0) {
      console.log("scroll top!")
      const previousScrollHeight = this.container.nativeElement.scrollHeight
      this.commentLimit += 100
      this.resubscribeComments(() => {
        setTimeout(() => {
          this.container.nativeElement.scrollTop = this.container.nativeElement.scrollHeight - previousScrollHeight
        }, 30)
      })
    }
    */
  }

  private static heightLog(elem: HTMLElement) {
    if (environment.production) {
      return
    }
    // console.log({
    //   scrollTop: elem.scrollTop,
    //   scrollHeight: elem.scrollHeight,
    //   offsetTop: elem.offsetTop,
    //   offsetHeight: elem.offsetHeight,
    //   clientTop: elem.clientTop,
    //   clientHeight: elem.clientHeight,
    // })
  }

  /**
   * 最新コメントにギフトが含まれている場合はアニメーションを描画する
   */
  startAnimation(giftMeta: GiftMeta): void {
    let animationPath = ''
    if (environment.name === 'local') {
      animationPath = `assets/animations/data/gifts/GO1pa1yv44qb8HggWAPl/animations/default.json`
    } else {
      animationPath = giftMeta.animationPath
    }
    const request: GiftAnimationReq = {
      path: animationPath,
      count: giftMeta.giftQuantity,
      giftName: giftMeta.giftName,
      labelColorNumber: giftMeta.labelColorNumber,
      senderId: giftMeta.senderId
    }
    this.setAnimationEvent.emit(request)
  }

  /**
   * ローカルではstgの画像が参照できないのでpathを固定する
   */
  getGiftIconPath(iconPath: string) {
    if (environment.name === 'local') {
      // return `/assets/animations${iconPath}`
      return `https://live.stg.mag2.com${iconPath}`
    } else {
      return iconPath
    }
  }
}